import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
import Lg from "language"
import { thaiBath } from "helpers/ConvertFormat"
import Auth from "auth"
import AuthRoutes from "routes/auth.jsx"
import Wording from "configs/Wording.jsx"
import { compose } from "recompose"
import { connect } from "react-redux"
import { creditUpdate } from "store/actions"
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";

import dashboardRoutes from "routes/dashboard.jsx";

import appStyle from "assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.jsx";

import image from "assets/img/sidebar-nmt.jpg";
// import image from "assets/img/sidebar-mizuno.jpg";
// import image from "assets/img/sidebar-3.jpg";
import logo from "assets/img/logo-mini.png";
// import logo from "assets/img/reactlogo.png";
// import logo from "assets/img/logo-white.svg";

const switchRoutes = (
  <Switch>
    {dashboardRoutes.map((prop, key) => {
      if (prop.redirect)
        return <Redirect from={prop.defaultpath} to={prop.pathTo} key={key} />;

      if (prop.forGuest && Auth.isAuthentication()) {
        const user_type_code = Auth.getUserData().user_type_code
        if (AuthRoutes[user_type_code] != undefined) {
          return (
            <Redirect from={prop.path} to={AuthRoutes[user_type_code].forNoGuest} key={key} />
          );
        } else {
          return (
            <Redirect from={prop.path} to={AuthRoutes.default.forNoGuest} key={key} />
          );
        }
      }
      if (prop.forLogin && !Auth.isAuthentication()) {
        return (
          <Redirect from={prop.path} to={AuthRoutes.default.forNoLogin} key={key} />
        );
      }
      if (prop.collapse)
        return prop.views.map((prop, key) => {
          return (
            <Route path={prop.path} component={prop.component} key={key} />
          );
        });
      return <Route path={prop.path} component={prop.component} key={key} />;
    })}
  </Switch>
);

var ps;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      miniActive: false,
      credit_used: 0,
      credit_success: 0,
      credit_rollback: 0,
      credit_have: 0,
      credit: null
    };
    this.resizeFunction = this.resizeFunction.bind(this);
  }
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.mainPanel, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", this.resizeFunction);
    if (Auth.isAuthentication()) {
      this.props.creditUpdate()
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
    window.removeEventListener("resize", this.resizeFunction);
  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
  }
  componentWillUpdate(nextProps, nextState) {
    if (nextProps.credit && nextProps.credit !== nextState.credit) {
      console.log(nextProps, nextState)
      this.setState({
        credit: nextProps.credit,
        credit_used: nextProps.credit.credit_used,
        credit_success: nextProps.credit.credit_success,
        credit_rollback: nextProps.credit.credit_rollback,
        credit_have: nextProps.credit.credit_have,
      })
    }
  }
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  getRoute() {
    return this.props.location.pathname !== "/maps/full-screen-maps";
  }
  sidebarMinimize() {
    this.setState({ miniActive: !this.state.miniActive });
  }
  resizeFunction() {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  }
  render() {
    const { classes, ...rest } = this.props;
    const mainPanel =
      classes.mainPanel +
      " " +
      cx({
        [classes.mainPanelSidebarMini]: this.state.miniActive,
        [classes.mainPanelWithPerfectScrollbar]:
          navigator.platform.indexOf("Win") > -1
      });
    return (
      <div className={classes.wrapper}>
        <Sidebar
          routes={dashboardRoutes}
          logoText={Wording.AppName}
          logo={logo}
          image={image}
          handleDrawerToggle={this.handleDrawerToggle}
          open={this.state.mobileOpen}
          color="blue"
          // color="orange"
          bgColor="black"
          miniActive={this.state.miniActive}
          userData={Auth.getUserData()}
          {...rest}
        />
        <div className={mainPanel} ref="mainPanel">
          <Header
            sidebarMinimize={this.sidebarMinimize.bind(this)}
            miniActive={this.state.miniActive}
            routes={dashboardRoutes}
            handleDrawerToggle={this.handleDrawerToggle}
            {...rest}
          />
          {/* On the /maps/full-screen-maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
          {this.getRoute() ? (
            <div className={classes.content}>
              <div className="bar-app-credit-point">
                <center>
                  {Lg.ts("ใช้ไปทั้งหมด")} <span className="txt-c-r2">{thaiBath(this.state.credit_used, false)}</span> {Lg.ts("เครดิต")}
                  , {Lg.ts("ยืนยันส่งสำเร็จ")} <span className="txt-c-r2">{thaiBath(this.state.credit_success, false)}</span> {Lg.ts("เครดิต")}
                  , {Lg.ts("คืน")} <span className="txt-c-g3">{thaiBath(this.state.credit_rollback, false)}</span> {Lg.ts("เครดิต")}
                  , {Lg.ts("เครดิตเหลือ")} <span className="txt-c-y2">{thaiBath(this.state.credit_have, false)}</span> {Lg.ts("เครดิต")}
                </center>
              </div>
              <div className={classes.container}>{switchRoutes}</div>
            </div>
          ) : (
              <div className={classes.map}>{switchRoutes}</div>
            )}
          {this.getRoute() ? <Footer fluid /> : null}
        </div>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps({ credit }) {
  return {
    credit: credit
  }
}

export default compose(
  withStyles(appStyle),
  connect(
    mapStateToProps,
    { creditUpdate }
  )
)(Dashboard)